import {combineReducers} from 'redux';

import {reducer} from './reducers/userReducer.js'

const commonreducer=combineReducers({
    userState:reducer
})

export default commonreducer

